<template>
    <div>
        <headline>
            Statistik
            <a v-if="this.zoneId" :href="`/admin/statistics/report-pdf?zone=${this.zoneId}&from=${this.from}&to=${this.to}`">
                <button-primary>PDF Exportieren</button-primary>
            </a>
            <template v-slot:more>
                <div class="flex justify-between">
                    <t-datepicker
                        :clearable="false"
                        class="mr-2 mt-5"
                        v-model="dateRange"
                        userFormat="d.m.Y"
                        range
                    >
                    </t-datepicker>
                    <div>
                        <label class="block text-sm font-medium text-gray-700">Tage</label>
                        <select-menu v-model="days"
                                     :text='["Werktage (Mo-Fr)", "Berücksichtigung der Feiertage","Alle"]'
                                     :values="['activeWorkingDays', 'generalWorkingDays','all']"
                                     class="mr-2">
                        </select-menu>
                    </div>
                    <div v-show="floors">
                        <label class="block text-sm font-medium text-gray-700">Etage</label>
                        <select-menu v-model="floorId"
                                     :text="textFloors"
                                     :values="valuesFloors"
                                     class="mr-2">
                        </select-menu>
                    </div>
                    <div v-show="zones">
                        <label class="block text-sm font-medium text-gray-700">Zone</label>
                        <select-menu v-model="zoneId"
                                     :text="textZones"
                                     :values="valuesZones">
                        </select-menu>
                    </div>
                  <button-secondary @click="download" class="mt-6 ml-1">
                    <i class="fa fa-download mr-2"></i>
                    Export
                  </button-secondary>
                </div>
            </template>
        </headline>
        <loading v-show="loading"></loading>
        <booking-statistic :zoneId="zoneId" :floorId="floorId" :from="from" :to="to" :days="days"
                           @setLoading="setLoading"></booking-statistic>
        <hourly-attendance-statistic class="mt-16" @setLoading="setLoading">
        </hourly-attendance-statistic>
        <portal to="modal" v-if="showModal">
            <modal @close="showModal = false">
                <template v-slot:header>Schicken Sie das PDF an</template>

                <input-text v-model="email" class="mb-8">
                    Email
                </input-text>

                <div class="flex justify-end">
                    <button-primary :disabled="!email" @click="sendPdf">Senden</button-primary>
                </div>

            </modal>
        </portal>
    </div>
</template>

<script>

import ChartLine from "../components/Chart/ChartLine.vue"
import HourlyAttendanceStatistic from "../components/HourlyAttendanceStatistic.vue";
import BookingStatistic from "../components/BookingStatistic.vue"
import Headline from "../components/UI/Headline.vue"
import ButtonSecondary from "../components/UI/ButtonSecondary.vue"
import ButtonPrimary from "../components/UI/ButtonPrimary.vue"
import SelectMenu from "../components/UI/SelectMenu.vue"
import Modal from "../components/Modal.vue";
import InputText from "../components/UI/InputText.vue";
import Loading from "../components/UI/Loading.vue";
import {format} from "date-fns";
import ButtonWhite from "../components/UI/ButtonWhite.vue";

export default {
    name: "Statistics",
    components: {
      ButtonWhite,

        ChartLine,
        HourlyAttendanceStatistic,
        BookingStatistic,
        Headline,
        ButtonSecondary,
        SelectMenu,
        Modal,
        ButtonPrimary,
        InputText,
        Loading,
    },

    data: () => ({
        loading: false,
        email: "",
        showModal: false,
        zones: [],
        floors: [],
        zoneId: null,
        floorId: null,
        disableWatch: false,
        days: "activeWorkingDays",
        dateRange: [
            format(new Date((new Date).getFullYear(), (new Date).getMonth(), 1), 'yyyy-MM-dd'),
            format(new Date((new Date).getFullYear(), (new Date).getMonth() + 1, 0), 'yyyy-MM-dd')
        ],
    }),

    mounted() {
        this.load();
    },

    watch: {
        floorId() {
            if (!this.disableWatch) {
                this.disableWatch = true;
                this.zoneId = null;
                setTimeout(function () {
                    this.disableWatch = false;
                }.bind(this), 100);
            }
        }
        ,
        zoneId() {
            if (!this.disableWatch) {
                this.disableWatch = true;
                this.floorId = null;
                setTimeout(function () {
                    this.disableWatch = false;
                }.bind(this), 100);
            }
        }
    }
    ,

    computed: {
        from() {
            return this.dateRange[0];
        },
        to() {
            return this.dateRange[1];
        }
        ,
        textFloors() {
            return ['Alle'].concat(this.floors.map(p => p.name));
        }
        ,
        valuesFloors() {
            return [null].concat(this.floors.map(p => p.id));
        }
        ,
        textZones() {
            return ['Alle'].concat(this.zones.map(p => p.name));
        }
        ,
        valuesZones() {
            return [null].concat(this.zones.map(p => p.id));
        }
        ,
    }
    ,

    methods: {
        download() {
          window.open(`/admin/weekly_stats/export?from=${this.from}&to=${this.to}&zone=${this.zoneId}&floor=${this.floorId}&days=${this.days}`)
        },
        load() {
            this.loading = true;
            axios.get('/admin/desks').then(response => {
                this.floors = response.data.floors;
                this.zones = response.data.groups;
                this.loading = false;
            }).catch(error => {
                this.loading = false;
                this.$root.$emit('error', error);
            });
        }
        ,
        sendPdf() {
            this.showModal = false;
            this.loading = true;
            this.$http
                .get(`/admin/statistics-pdf?zone=${this.zoneId}`)
                .then(() => {
                    this.loading = false;
                    this.$root.$emit('alert', 'PDF gesendet!');
                }).catch(error => {
                this.loading = false;
                this.$root.$emit('error', error);
            })
        }
        ,
        setLoading(flag) {
            this.loading = flag;
        }
    }
}
</script>

